import _ from 'underscore';

import {writeFragmentsToCache} from 'graphql-client/ApolloWrappers';
import {GraphQLRequestSampleGroupsRelationship} from 'requests/graphql/__generated/GraphQLRequestSampleGroupsRelationship';
import {RequestSampleGroupsRelationshipFragment} from 'requests/graphql/Request';
import {requestSampleGroupsFetchCompleted} from 'requests/inputs/InputReduxActions';
import {RequestInputsState} from 'requests/inputs/reduceInputs';

import Syncer from '../Syncer';

export type ReduxRequestSampleGroupsRelationship = RequestInputsState['sampleGroupIdsByRequestTaskId'];

function toGraphQL(
  sampleGroupIdsByRequestId: ReduxRequestSampleGroupsRelationship
): Array<GraphQLRequestSampleGroupsRelationship> {
  return Object.entries(sampleGroupIdsByRequestId).map(([requestId, sampleGroupIds]) => ({
    __typename: 'RequestNode',
    id: requestId,
    sampleGroups: sampleGroupIds.map((sampleGroupId) => ({
      __typename: 'SampleGroupNode',
      id: sampleGroupId,
    })),
  }));
}

export default class RequestSampleGroupsRelationshipSyncer extends Syncer<
  ReduxRequestSampleGroupsRelationship,
  GraphQLRequestSampleGroupsRelationship
> {
  readFromStore(): {current: ReduxRequestSampleGroupsRelationship; equalityRef: unknown} {
    const sampleGroupIdsByRequestId = this.reduxState().models.requests.inputs.sampleGroupIdsByRequestId;
    return {
      current: sampleGroupIdsByRequestId,
      equalityRef: sampleGroupIdsByRequestId,
    };
  }

  writeToApolloCache(inputs: ReduxRequestSampleGroupsRelationship): void {
    writeFragmentsToCache(RequestSampleGroupsRelationshipFragment, toGraphQL(inputs));
  }

  writeToStore(requests: Array<GraphQLRequestSampleGroupsRelationship>): void {
    const sampleGroupIdsByRequestId = _.mapObject(
      _.indexBy(requests, (request) => request.id),
      (request) => request.sampleGroups.map((sampleGroup) => sampleGroup.id)
    );

    this.dispatch(requestSampleGroupsFetchCompleted(sampleGroupIdsByRequestId));
  }
}
